import { Navigate, Outlet } from "react-router-dom";
import { getToken, isAdmin } from "./auth";

export default function AdminRoute() {
    const token = getToken();

    if (!token) return <Navigate to="/login" replace />;

    return isAdmin() ? <Outlet /> : <Navigate to="/" replace />;
}